import { useState, useEffect } from "react";
import "./AddFolder.scss";
import { motion } from "framer-motion";
import folder from "../../img/folder.png";
import { Button } from "../Button/Button";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import {
  handleBottomDrawer,
  handleBottomDrawerAddFolder,
} from "../../actions/actionCreators";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import {
  createFolder,
  getAllFolders,
} from "../../actions/folders-actions/actions";
import {
  clearAllAlerts,
  removeAlert,
  setAlert,
} from "../../actions/alerts-actions/actions";
// import { Select } from "antd";
import Select, { components } from "react-select";
import { v4 as uuidv4 } from "uuid";
import Alert from "../Alert/Alert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFolderPlus,
  faFolderOpen,
  faCaretDown,
} from "@fortawesome/free-solid-svg-icons";
import { getGenders } from "../../actions/left-menu-actions/actions";
import shoppingBag from "../../img/shoppingBag.svg";
import { AddOrderBottomDrawer } from "./AddOrderBottomDrawer";
import {
  createArticle,
  getCollaborators,
} from "../../actions/order-actions/actions";
import { addOrder } from "../../actions/order-actions/actions";
import { BrowserRouter, useParams, useLocation } from "react-router-dom";
import { AddArticleBottomDrawer } from "./AddArticleBottomDrawer";
import { history } from "../../index";
import Bag from "../../icons/Bag";

export interface IAddFolderProps {
  setMode: ((mode: string) => void) | undefined;
  withRoot: boolean;
  addFolder?: boolean;
  addArticle?: boolean;
  addOrderDrawer?: boolean;
}

export default function AddFolder({
  setMode,
  withRoot,
  addArticle,
  addOrderDrawer,
  addFolder,
}: IAddFolderProps) {
  const CaretDownIcon = () => {
    return <FontAwesomeIcon icon={faCaretDown} />;
  };

  const FolderIcon = () => {
    return <FontAwesomeIcon icon={faFolderOpen} />;
  };

  const DropdownIndicator = (props: any) => {
    return (
      <components.DropdownIndicator {...props}>
        {addArticle || addOrderDrawer ? <CaretDownIcon /> : <FolderIcon />}
      </components.DropdownIndicator>
    );
  };
  const [options, setoptions] = useState([]);
  const [genders, setgenders] = useState([]);
  const [width, setWidth] = useState(window.innerWidth);
  const [fodlerSelected, setfodlerSelected] = useState<any>("");
  const [selectDivision, setSelectDivision] = useState<any>("");
  const [height, setHeight] = useState(window.innerHeight);
  const [allGenders, setAllGenders] = useState([]);
  const [folderData, setfolderData] = useState({
    name: "",
    description: "",
  });
  const [tags, setTags] = useState([]);
  const [data, setData] = useState<any>({
    name: "",
    details: "",
    collaborator: [],
  });
  const [lastFetchId, setLastFetchId] = useState(0);
  const [state, setState] = useState({
    users: [],
    value: [],
    fetching: false,
  });
  const params: any = useParams();

  const location: any = useLocation();
  // GET COLLEAGUES
  const fetchUser = (value: any) => {
    setLastFetchId(lastFetchId + 1);
    setState({ ...state, users: [], fetching: true });
    fetch("https://randomuser.me/api/?results=5")
      .then((response) => response.json())
      .then((body) => {
        if (lastFetchId !== lastFetchId) {
          // for fetch callback order
          return;
        }
        const users = body.results.map((user: any) => ({
          text: `${user.name.first} ${user.name.last}`,
          value: user.login.username,
        }));
        setState({ ...state, users, fetching: false });
      });
  };

  const handleChangeOrder = (e: any) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const handleChangeGender = (e: any) => {
    setData({ ...data, gender: e.value });
  };
  const { collaborators, newOrder, orders, createOrderLoading } = useSelector(
    (state: any) => state.orders
  );
  const alerts = useSelector((state: any) => state.alerts);
  const folders = useSelector((state: any) => state.folders);
  const leftMenu = useSelector((state: any) => state.leftMenu);
  const [orderCreated, setOrderCreated] = useState<any>(null);
  const handleChange2 = (value: any) => {
    setData({ ...data, collaborator: value });
    setState({
      ...state,
      value,
      users: [],
      fetching: false,
    });
  };

  useEffect(() => {
    if (addOrderDrawer) {
      dispatch(getCollaborators(""));
    }
    if (addArticle) {
      dispatch(getGenders());
    }
  }, []);

  useEffect(() => {
    if (leftMenu.allGenders.data) {
      setAllGenders(
        leftMenu.allGenders.data.map((el: any) => {
          return {
            label: el.name,
            value: el.id,
          };
        })
      );
    }
  }, [leftMenu.allGenders]);

  const handleCollabChange = (e: any) => {
    setData({
      ...data,
      collaborator: e && e.map((el: any) => el.value),
    });
  };

  // useEffect(() => {
  //   if (newOrder) {
  //     setOrderCreated(newOrder);
  //     history.push(`/edit-order/${newOrder.id}`);
  //   }
  // }, [newOrder]);

  // const filterColors = (inputValue: any) => {
  //   return (
  //     collaborators &&
  //     collaborators.filter((i: any) =>
  //       i.name.toLowerCase().includes(inputValue.toLowerCase())
  //     )
  //   );
  // };

  // const promiseOptions = (inputValue: any) =>
  //   new Promise((resolve) => {
  //     dispatch(getCollaborators(inputValue));
  //     resolve(
  //       collaborators
  //         .map((el: any) => {
  //           return {
  //             label: el.name,
  //             value: el.name,
  //           };
  //         })
  //         .filter((i: any) =>
  //           i.label.toLowerCase().includes(inputValue.toLowerCase())
  //         )
  //     );
  //     setData({
  //       ...data,
  //       collaborator: [
  //         ...data.collaborator,
  //         collaborators
  //           .map((el: any) => {
  //             return {
  //               label: el.name,
  //               value: el.name,
  //             };
  //           })
  //           .filter((i: any) =>
  //             i.label.toLowerCase().includes(inputValue.toLowerCase())
  //           ),
  //       ],
  //     });
  // setTimeout(() => {
  // resolve(filterColors(inputValue));
  // }, 1000);
  // });

  // useEffect(() => {
  //   filterColors(collaborators);
  // }, [collaborators]);

  const variants = {
    enter: { y: 1900 },
    center: { y: height },
    exit: { y: 1900 },
  };

  const handleChange = (e: any) => {
    setfolderData({ ...folderData, [e.target.name]: e.target.value });
  };
  const createNewFolder = () => {
    if (folderData.name === "") {
      var id = uuidv4();

      dispatch(setAlert("Please specify the folder name!", "danger", id));
      setTimeout(() => {
        dispatch(removeAlert(id));
      }, 5000);
      return null;
    } else if (withRoot) {
      dispatch(
        createFolder({
          ...folderData,
          ...tags,
          parent_id: fodlerSelected.value,
          product_id: params.productId,
        })
      );
      dispatch(handleBottomDrawer());
      // dispatch(getAllFolders());
      dispatch(clearAllAlerts());
      var id = uuidv4();
      dispatch(setAlert("Folder added successfully", "success", id));
      setTimeout(() => {
        dispatch(removeAlert(id));
      }, 5000);
    } else {
      dispatch(createFolder({ ...folderData, ...tags }));
      dispatch(handleBottomDrawer());
      // dispatch(getAllFolders());
      dispatch(clearAllAlerts());
      var id = uuidv4();
      dispatch(setAlert("Folder added successfully", "success", id));
      setTimeout(() => {
        dispatch(removeAlert(id));
      }, 5000);
    }

    setfodlerSelected("");
    setfolderData({
      name: "",
      description: "",
    });
    setTags([]);
  };

  const discard = () => {
    setfolderData({
      name: "",
      description: "",
    });
    setTags([]);
    dispatch(clearAllAlerts());
  };

  useEffect(() => {
    const resize: any = window.addEventListener("resize", () => {
      setWidth(window.innerWidth);
    });
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [width]);
  useEffect(() => {
    setHeight(window.innerHeight);
  }, [window.innerHeight]);
  useEffect(() => {
    folders.folders &&
      setoptions(
        folders.folders.map((el: any) => {
          return { value: el.id, label: el.name };
        })
      );
    if (addArticle) {
      dispatch(getGenders());
    }
    leftMenu.allGenders.data &&
      setgenders(
        leftMenu.allGenders.data.map((el: any) => {
          return { value: el.id, label: el.name };
        })
      );
    if (withRoot) {
      dispatch(getAllFolders());
    }
  }, []);
  const dispatch = useDispatch();

  const customStyles = {
    //@ts-ignore
    option: (styles: any, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected ? "#00468c" : null,
        color: isSelected ? "white" : "black",
      };
    },
    control: (base: any) => ({
      ...base,
      border: 0,
      borderBottom: "1px solid #ccc",
      borderRadius: 0,
      padding: 0,
      // This line disable the blue border
      boxShadow: "none",
      "&:hover": {
        outine: "none",
      },
    }),
    menuList: (provided: any, state: any) => ({
      ...provided,
      paddingLeft: 0,
      paddingBottom: 0,
    }),
    menu: (base: any) => ({
      ...base,
      marginTop: 0,
      color: "#00468c",
    }),
    valueContainer: (base: any) => ({
      ...base,
      paddingLeft: 0,
      fontSize: 18,
    }),
    indicatorSeparator: (base: any) => ({
      ...base,
      display: "none",
    }),
    colors: (base: any) => ({
      ...base,
      primary: "#00468c",
      primary25: "#00468c",
    }),
  };

  return (
    <BrowserRouter>
      <motion.div
        className={
          addOrderDrawer
            ? "add_folder_container add_order_container"
            : "add_folder_container"
        }
        style={{
          height: addOrderDrawer ? "100vh" : "calc(100vh - 109px)",
          justifyContent: addOrderDrawer ? "flex-start" : "space-between",
        }}
        transition={{ type: "tween" }}
        variants={variants}
        initial="enter"
        animate="center"
        exit="exit"
      >
        <div className="add_folder_top">
          {!addArticle && !addOrderDrawer && (
            <img src={folder} alt="folder image" className="folder_img" />
          )}
          {addOrderDrawer && (
            // <img src={shoppingBag} alt="order icon" className="order_img" />
            <Bag />
          )}
          {addArticle ? (
            <h3>Add new Article</h3>
          ) : addOrderDrawer ? (
            <h3>Add New Order</h3>
          ) : (
            <h3>Add New Folder</h3>
          )}
        </div>
        <div className="container">
          {addArticle ? (
            <AddArticleBottomDrawer
              handleChange={(x: any) => handleChange(x)}
              options={options}
              DropdownIndicator={DropdownIndicator}
              customStyles={customStyles}
              genders={allGenders}
              setfodlerSelected={setfodlerSelected}
              setSelectDivision={setSelectDivision}
            />
          ) : addOrderDrawer ? (
            <AddOrderBottomDrawer
              handleChangeGender={handleChangeGender}
              handleChangeOrder={handleChangeOrder}
              state={state}
              handleChange2={handleChange2}
              fetchUser={fetchUser}
              // promiseOptions={promiseOptions}
              handleCollabChange={handleCollabChange}
              collaborators={collaborators}
            />
          ) : (
            <div style={{ width: "100%" }} className="container-fluid">
              <div className="form_add_folder">
                <div className="form_add_folder_left col-12 col-md-6">
                  <div className="field">
                    <input
                      type="text"
                      name="name"
                      id="name"
                      placeholder=" "
                      onChange={handleChange}
                    />
                    <label htmlFor="name" className="folder_label">
                      Folder Name
                    </label>
                  </div>
                  {withRoot ? (
                    <div className="field">
                      <Select
                        options={options}
                        styles={customStyles}
                        //@ts-ignore
                        onChange={setfodlerSelected}
                        placeHolder="Select The Parent Folder"
                        components={{ DropdownIndicator }}
                      />
                    </div>
                  ) : (
                    <div className="field tags_field">
                      <TagsInput
                        value={tags}
                        onChange={setTags}
                        className="react-tagsinput"
                      />
                      <label htmlFor="tags" className="tags_label">
                        Add Tags
                      </label>
                    </div>
                  )}
                </div>
                {width >= 768 && (
                  <div className="form_add_folder_right col-12 col-md-6">
                    <label htmlFor="a" className="folder_description_label">
                      Folder Description
                    </label>
                    <textarea
                      name="description"
                      id="description"
                      placeholder=""
                      onChange={handleChange}
                    />
                  </div>
                )}
              </div>
              {withRoot && (
                <div
                  className="field tags_field"
                  style={{ padding: "16px 28px 24px" }}
                >
                  <TagsInput
                    value={tags}
                    onChange={setTags}
                    className="react-tagsinput"
                  />
                  <label htmlFor="tags" className="tags_label">
                    Add Tags
                  </label>
                </div>
              )}
              {width < 768 && (
                <div className="form_add_folder_right col-12 col-md-6">
                  <label htmlFor="a" className="folder_description_label">
                    Folder Description
                  </label>
                  <textarea
                    name="description"
                    id="description"
                    placeholder=""
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>
          )}
        </div>

        <div
          className="buttons buttons_form container"
          style={{ bottom: addOrderDrawer ? "86px" : "0px" }}
        >
          <Button
            innerButton="Discard"
            buttonClass="submit_button_white submit_button_white_discard"
            onClick={() => {
              if (addFolder) {
                // dispatch(handleBottomDrawerAddFolder());
                setMode && setMode("add_to_collection");
              } else {
                setMode && setMode("add_to_collection");
                dispatch(clearAllAlerts());
                discard();
                dispatch(handleBottomDrawer());
              }
            }}
          />
          <Button
            innerButton={createOrderLoading ? "Confirming..." : "Confirm"}
            buttonClass="submit_button_white submit_button_white_confirm"
            onClick={async () => {
              if (addOrderDrawer) {
                if (data.details && data.name) {
                  // dispatch(handleBottomDrawer());
                  dispatch(addOrder(data, true));
                } else {
                  // dispatch(handleBottomDrawer());
                  dispatch(addOrder(data, true));
                }

                // history.push("/new-order");
                // return <Redirect to="/new-order" />;
              }
              // else if (addArticle) {
              //   if (folderData.name) {
              //     dispatch(
              //       createArticle(
              //         {
              //           ...folderData,
              //           gender: fodlerSelected.value,
              //           division: selectDivision.label,
              //           order_id:
              //             location.pathname === "/new-order"
              //               ? orders[0].id
              //               : Number(params.id),
              //         },
              //         true
              //       )
              //     );
              //     dispatch(handleBottomDrawer());
              //   } else {
              //     dispatch(
              //       createArticle(
              //         {
              //           ...folderData,
              //           gender: fodlerSelected.value,
              //           order_id:
              //             location.pathname === "/new-order"
              //               ? orders[0].id
              //               : Number(params.id),
              //         },
              //         true
              //       )
              //     );
              //   }
              // }
              else {
                createNewFolder();
              }
            }}
          />
        </div>
        {/* <div className="alerts_position">
          {alerts.alerts.map((el: any) => (
            <Alert alert={el} className="alert_missing_fodler_name" />
          ))}
        </div> */}
      </motion.div>
    </BrowserRouter>
  );
}
